// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-J":"J_dpu-detail-J__16wac"};